import {useEffect} from 'react';
import {analyticsHandler} from '@/services/analytics/analytics-handler';
import {UserRolePropertyEvent} from '@/services/analytics/analytics-types';

export const useUserRolePropertyEvent = (userRole: UserRolePropertyEvent['event_detail']['user_role_property']) => {
  useEffect(() => {
    analyticsHandler.userRoleProperty({
      user_role_property: userRole,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
